module.exports = __webpack_public_path__ + "static/media/maestro_logo_tagline_grad_white.c12febd2.svg";